export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6376.eb7f6abc.jpg";